import React, { useState } from 'react'

const RefundProxyConfirmDialog = (props) => {
    const [selectedQuickReason, setSelectedQuickReason] = useState("")

    const quickReasons = [
        "Not working",
        "IP mismatch at purchase", 
        "Country geolocation mismatch"
    ]

    const handleClose = () => {
        props.setOpenConfirmRefund(false)
        setSelectedQuickReason("")
    }

    const handleRefund = () => {
        try {
            props.refundProxy(selectedQuickReason)
        } catch (e) {
            throw e
        } 
    }
    
    const handleQuickReasonClick = (reason) => {
        setSelectedQuickReason(reason)
    }

    const isReasonSelected = Boolean(selectedQuickReason)
  
  return (
      <>
          {/* Модальное окно подтверждения возврата */}
          {props.openConfirmRefund && (
              <div style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10000
              }} onClick={handleClose}>
                  <div style={{
                      background: 'var(--medium-gray)',
                      border: '1px solid var(--light-gray)',
                      borderRadius: 'var(--radius-lg)',
                      padding: 'var(--spacing-2xl)',
                      maxWidth: '500px',
                      width: '90%',
                      boxShadow: 'var(--shadow-card)',
                      position: 'relative'
                  }} onClick={(e) => e.stopPropagation()}>
                      
                      {/* Кнопка закрытия */}
                      <button
                          onClick={handleClose}
                          style={{
                              position: 'absolute',
                              top: 'var(--spacing-md)',
                              right: 'var(--spacing-md)',
                              background: 'none',
                              border: 'none',
                              color: 'var(--text-muted)',
                              fontSize: 'var(--text-xl)',
                              cursor: 'pointer',
                              padding: '4px'
                          }}
                      >
                          ✕
                      </button>

                      {/* Заголовок */}
                      <h2 style={{
                          color: 'var(--text-light)',
                          fontSize: 'var(--text-2xl)',
                          fontWeight: '700',
                          marginBottom: 'var(--spacing-xl)',
                          textAlign: 'center',
                          background: 'var(--gradient-orange)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text'
                      }}>
                          Refund Proxy Confirm
                      </h2>

                      {/* Информация о возврате */}
                      <div style={{
                          background: 'var(--dark-gray)',
                          border: '1px solid var(--light-gray)',
                          borderRadius: 'var(--radius-md)',
                          padding: 'var(--spacing-lg)',
                          marginBottom: 'var(--spacing-lg)',
                          textAlign: 'center'
                      }}>
                          <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 'var(--spacing-md)',
                              marginBottom: 'var(--spacing-md)'
                          }}>
                              <div style={{
                                  background: '#dc3545',
                                  borderRadius: '50%',
                                  width: '48px',
                                  height: '48px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '24px'
                              }}>
                                  💰
                              </div>
                              <div>
                                  <h3 style={{
                                      color: 'var(--text-light)',
                                      fontSize: 'var(--text-lg)',
                                      fontWeight: '600',
                                      margin: '0 0 var(--spacing-xs) 0'
                                  }}>
                                      Proxy Refund
                                  </h3>
                                  <p style={{
                                      color: 'var(--text-muted)',
                                      fontSize: 'var(--text-sm)',
                                      margin: '0'
                                  }}>
                                      Request refund for proxy
                                  </p>
                              </div>
                          </div>

                          <p style={{
                              color: 'var(--text-light)',
                              fontSize: 'var(--text-sm)',
                              margin: '0',
                              lineHeight: '1.5'
                          }}>
                              By clicking the refund button, a refund ticket for proxy{' '}
                              <span style={{
                                  color: 'var(--primary-orange)',
                                  fontWeight: '700',
                                  fontFamily: 'var(--font-mono)'
                              }}>
                                  {props.selectedProxy?.id}
                              </span>{' '}
                              will be created.
                          </p>
                      </div>

                      {/* Быстрые варианты причин */}
                      <div style={{ marginBottom: 'var(--spacing-xl)' }}>
                          <label style={{
                              color: 'var(--text-light)',
                              fontSize: 'var(--text-sm)',
                              fontWeight: '600',
                              marginBottom: 'var(--spacing-md)',
                              display: 'block'
                          }}>
                              Quick reason selection:
                          </label>
                          <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 'var(--spacing-sm)'
                          }}>
                              {quickReasons.map((reason, index) => (
                                  <button
                                      key={index}
                                      onClick={() => handleQuickReasonClick(reason)}
                                      style={{
                                          background: selectedQuickReason === reason ? 'var(--primary-orange)' : 'var(--dark-gray)',
                                          border: `2px solid ${selectedQuickReason === reason ? 'var(--primary-orange)' : 'var(--light-gray)'}`,
                                          borderRadius: 'var(--radius-md)',
                                          padding: 'var(--spacing-md)',
                                          color: selectedQuickReason === reason ? 'var(--white)' : 'var(--text-light)',
                                          fontSize: 'var(--text-sm)',
                                          fontWeight: '500',
                                          cursor: 'pointer',
                                          transition: 'var(--transition-normal)',
                                          textAlign: 'left'
                                      }}
                                      onMouseEnter={(e) => {
                                          if (selectedQuickReason !== reason) {
                                              e.target.style.borderColor = 'var(--primary-orange)'
                                              e.target.style.color = 'var(--primary-orange)'
                                          }
                                      }}
                                      onMouseLeave={(e) => {
                                          if (selectedQuickReason !== reason) {
                                              e.target.style.borderColor = 'var(--light-gray)'
                                              e.target.style.color = 'var(--text-light)'
                                          }
                                      }}
                                  >
                                      {reason}
                                  </button>
                              ))}
                          </div>
                      </div>

                      {/* Кнопки */}
                      <div style={{
                          display: 'flex',
                          gap: 'var(--spacing-md)',
                          justifyContent: 'flex-end'
                      }}>
                          <button
                              onClick={handleClose}
                              className="btn btn-outline"
                              style={{ minWidth: '100px' }}
                          >
                              Cancel
                          </button>
                          <button
                              onClick={handleRefund}
                              className="btn btn-primary"
                              style={{ 
                                  minWidth: '120px',
                                  opacity: isReasonSelected ? 1 : 0.5,
                                  cursor: isReasonSelected ? 'pointer' : 'not-allowed'
                              }}
                              disabled={!isReasonSelected}
                    >
                Refund
                          </button>
                      </div>
                  </div>
              </div>
          )}
      </>
  )
}

export default RefundProxyConfirmDialog